/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Create_Table_DescriptionInputs */



/**
* | output |
* | --- |
* | "Define a table by naming it and adding typed columns." |
*
* @param {Datasets_Create_Table_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_create_table_description = /** @type {((inputs?: Datasets_Create_Table_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Create_Table_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Definieren Sie eine Tabelle, indem Sie sie benennen und typisierte Spalten hinzufügen.")
	return /** @type {LocalizedString} */ ("Define a table by naming it and adding typed columns.")
});